export default class JobUserNotify {
    userIds: Array<number>;
    jobId: number;
    nodeId: number;
}
